import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { FacetId } from "../../../../../../types.js";
import { CurrentRefinements } from "../../../../CurrentRefinements/Algolia/components/CurrentRefinements/CurrentRefinements.js";
import { ConnectedFacetInputList } from "../../../../FacetInputList/Algolia/components/FacetInputList/ConnectedFacetInputList.js";
import { ConnectedFacetInputPriceRange } from "../../../../FacetInputPriceRange/Algolia/components/FacetInputPriceRange/ConnectedFacetInputPriceRange.js";
/* empty css                   */
const FacetsDesktop = ({ facets }) => {
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement("div", { className: "facets-desktop" }, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "facets-desktop__top-bar",
      role: "toolbar",
      tabIndex: 0,
      "aria-labelledby": "filters",
      "data-t": "facets-desktop-list"
    },
    /* @__PURE__ */ React.createElement("h2", { id: "filters", className: "sr-only" }, getLabel("products.filters")),
    facets.map((facet) => {
      const FacetComponent = facet.id === FacetId.price ? ConnectedFacetInputPriceRange : ConnectedFacetInputList;
      return /* @__PURE__ */ React.createElement(FacetComponent, { key: facet.attribute, facet });
    })
  ), /* @__PURE__ */ React.createElement("div", { className: "facets-desktop__refinements" }, /* @__PURE__ */ React.createElement(CurrentRefinements, null)));
};
export {
  FacetsDesktop as default
};
//# sourceMappingURL=FacetsDesktop.js.map
